<template>
  <div>
    <span 
      v-if="type=='button'"
    >
      <v-icon
        color="blue darken-2"
        :disabled="document.estatus.descripcion === 'Firmado'"
        @click="click"
        >{{ icon.pencil }}</v-icon
      >
    </span>
    <v-list-item
      v-else-if="type=='list'"
      :disabled="document.estatus.descripcion === 'Firmado'"
      @click.stop="clickList"
    >
      <v-list-item-title>Editar</v-list-item-title>
    </v-list-item>
    <component
      :is="componentDialog"
      show
      v-model="document"
      @close="close"
    />
  </div>
</template>

<script>
import { mdiPencilOutline } from '@mdi/js'
import DocumentDialog from './DocumentDialog'

export default {
  name: 'DocumentUpdate',
  components: {
    DocumentDialog
  },
  props: {
    value: {
      type: Object
    },
    type: {
      type: String,
      default: 'button'
    }
  },
  data(){
    return {
      icon: {
        pencil: mdiPencilOutline
      },
      componentDialog: ''
    }
  },
  computed: {
    document: {
      get() {
        return Object.assign({}, this.value)
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  },
  methods: {
    click() {
      this.componentDialog = 'DocumentDialog'
    },
    clickList(){
      this.componentDialog = 'DocumentDialog'
      this.$emit('click')
    },
    close() {
      this.componentDialog = ''
    }
  }
}
</script>
